import React, { useState, useCallback } from "react";
import { Formik } from "formik";
import {
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch } from "react-redux";
import map from "lodash/map";

import { addTms, updateTMS, deleteTMS } from "../../../../modules/factoring";
import BoldInput from "../../BoldInput";
import SpinnerButton from "../../../buttons/SpinnerButton";
import { DialogTitle, Dialog, DialogContent } from "../../../Dialog";
import { openSnackbar } from "../../../../modules/ui";

const TMSModal = ({
  handleClose,
  open,
  tmsList = [],
  setFieldPreviewValue
}) => {
  const dispatch = useDispatch();
  const [formAction, setFormAction] = useState("Add");
  const onSubmit = useCallback(
    async (fields, formikActions, formAction) => {
      try {
        formikActions.setSubmitting(true);
        let res;
        if (formAction === "Add") {
          res = await dispatch(addTms(fields.name));
        } else {
          res = await dispatch(updateTMS(fields));
        }

        setFieldPreviewValue("tms", res.id);
        dispatch(
          openSnackbar(
            "success",
            `TMS has been ${formAction === "Add" ? "added" : "updated"}.`
          )
        );
      } catch (e) {
        dispatch(
          openSnackbar(
            "error",
            `Error while ${formAction === "Add" ? "adding" : "updating"} TMS.`
          )
        );
      }
      formikActions.setSubmitting(false);
      formikActions.resetForm();
    },
    [dispatch]
  );

  const editAction = useCallback(({ setFieldValue, name, id }) => {
    setFieldValue("name", name);
    setFieldValue("id", id);
    setFormAction("Edit");
  }, []);
  const deleteAction = useCallback(
    (id, name, handleReset) => {
      try {
        handleReset();
        dispatch(deleteTMS(id));
        dispatch(
          openSnackbar("success", `${name.toUpperCase()} has been deleted.`)
        );
        setFormAction("Add");
      } catch (e) {
        dispatch(
          openSnackbar("error", `Error while deleting ${name.toUpperCase()}.`)
        );
      }
    },
    [dispatch]
  );
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle onClose={handleClose}>TMS</DialogTitle>
      <Formik
        onSubmit={(fields, formikActions) =>
          onSubmit(fields, formikActions, formAction)
        }
        initialValues={{
          name: "",
          id: ""
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          errors,
          handleReset
        }) => (
          <DialogContent>
            <Grid container direction="column" spacing={24}>
              <Grid item>
                <BoldInput
                  fullWidth
                  name="name"
                  label="Name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>
              <Grid
                item
                container
                justify={"flex-end"}
                alignItems={"flex-end"}
                xs
              >
                <SpinnerButton
                  disabled={isSubmitting}
                  style={{ justifySelf: "flex-end" }}
                  variant="raised"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {formAction === "Add" ? `Save` : `Update`}
                </SpinnerButton>
              </Grid>
              <Grid item>
                <List>
                  {map(tmsList, ({ name = "", id }) => (
                    <ListItem key={id}>
                      <ListItemText primary={name.toUpperCase()} />
                      <ListItemSecondaryAction>
                        <IconButton
                          aria-label="Edit"
                          onClick={() =>
                            editAction({ setFieldValue, name, id })
                          }
                        >
                          <EditIcon color={"secondary"} />
                        </IconButton>
                        <IconButton
                          aria-label="Delete"
                          onClick={() => deleteAction(id, name, handleReset)}
                        >
                          <DeleteIcon color={"error"} />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </DialogContent>
        )}
      </Formik>
    </Dialog>
  );
};

export default TMSModal;
